<template>
  <div class="outer donation-page">
    <v-card height="100%">
      <v-card-title>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs4
            align-center
            class="title"
          >
            Paynimo Donations
          </v-flex>

          <v-flex
            class="filter"
            xs4
          >
            <v-select
              v-model="selectedStatus"
              :items="statusList"
              label="Filter"
            ></v-select>
          </v-flex>

          <v-flex xs4>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>

        </v-layout>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="donationList"
        :search="search"
        :pagination.sync="pagination"
        item-key="key"
        :rows-per-page-items="[10, 25, 50, 100]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr @click="setActiveItem(props.item)">
            <td class="text-xs-left">{{ props.item.donorId }}</td>
            <td class="text-xs-left">{{ props.item.UMRN }}</td>
            <td class="text-xs-left name">{{ props.item.name }}</td>
            <!-- <td class="text-xs-left">{{ props.item.email }}</td> -->
            <!-- <td class="text-xs-left">{{ props.item.phone }}</td> -->
            <td class="text-xs-left no-wrap">{{ props.item.dateStart }}</td>
            <td class="text-xs-left no-wrap">{{ props.item.dateEnd }}</td>
            <td class="text-xs-center">{{ props.item.slot }}</td>
            <td class="text-xs-right">{{ props.item.amount }}</td>
            <td class="text-xs-right">
              <status
                :status="getLastStatus(props.item)"
                :msg="msg(props.item)"
              />
            </td>
            <!-- <td class="justify-center layout px-0">
                <v-btn icon class="mx-0" @click="editItem(props.item) ">
                  <v-icon color="info ">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(props.item) ">
                  <v-icon color="error ">delete</v-icon>
                </v-btn>
            </td>-->
          </tr>
        </template>
        <template slot="no-data ">Loading Data...</template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
    </v-card>

    <v-navigation-drawer
      v-model="drawer"
      width="330"
      fixed
      temporary
      hide-overlay
      right
      clipped
    >
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Donation Details</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

      <v-divider></v-divider>

      <div class="table__overflow">
        <table class="v-datatable v-table theme--light">
          <tbody>
            <tr class="contact">
              <td>Contact:</td>
              <td>
                <b class="name">{{activeItem.name}}</b>
                <br>
                <a :href="'mailto:'+activeItem.email">{{activeItem.email}}</a>
                <br>
                <a :href="'tel:'+activeItem.phone">{{activeItem.phone}}</a>
              </td>
            </tr>
            <tr>
              <td>
                <span>UMRN:</span>
              </td>
              <td>{{activeItem.UMRN}}</td>
            </tr>
            <tr>
              <td>
                <span>Created:</span>
              </td>
              <td>{{this.formatDate(activeItem.createdOn)}}</td>
            </tr>
            <tr>
              <td>
                <span>Updated:</span>
              </td>
              <td>{{formatDate(activeItem.updatedOn)}}</td>
            </tr>
            <tr>
              <td>
                <span>Last&nbsp;Status:</span>
              </td>
              <td>
                <status :status="getLastStatus(activeItem)" />
              </td>
            </tr>
            <!-- <tr class="status">
              <td>
                <span>Last Info:</span>
              </td>
              <td>{{activeItem.info}}</td>
            </tr> -->
            <tr class="history">
              <td>
                <span>History:</span>
              </td>
              <td>
                <history
                  :history="activeItem.history"
                  :regId="activeItem.key"
                  @click="handleHistoryClick"
                />
              </td>
            </tr>
            <tr class="loader">
              <td colspan="100%">
                <v-progress-linear
                  color="secondary"
                  height="2"
                  :indeterminate="isLoading"
                ></v-progress-linear>
              </td>
            </tr>
            <tr>
              <td>
                <span>Actions:</span>
              </td>
              <td>
                <v-btn
                  icon
                  class="mx-0"
                  title="Delete Scheduler &amp; Record permenantly"
                  @click="deleteItem(activeItem) "
                >
                  <v-icon color="error">delete</v-icon>
                </v-btn>

                <v-btn
                  icon
                  class="mx-0"
                  :disabled="isLoading"
                  title="Tigger Donate for this month"
                  @click="triggerDonate(activeItem) "
                >
                  <v-icon color="teal">play_circle_filled</v-icon>
                </v-btn>

                <!-- <v-btn
                  icon
                  class="mx-0"
                  :disabled="isLoading"
                  title="Check status"
                  @click="varifyTransaction(activeItem) "
                >
                  <v-icon color="teal">sync</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-navigation-drawer>

    <!-- <v-btn fab bottom left fixed color="accent " fixed @click.stop="dialog=! dialog ">
      <v-icon>add</v-icon>
    </v-btn>-->
  </div>
</template>


<script>
import axios from "axios";
import status from "@/components/status";
import history from "@/components/history";
import { get } from "lodash";
import { format } from "date-fns";
import { toDefaultDate, monthFromDate } from "@/assets/lib";

export default {
  components: { status, history },
  data: () => ({
    statusList: ["none", "success", "failed", "initiated", "triggered"],
    selectedStatus: "none",
    search: "",
    drawer: false,
    pagination: {
      sortBy: "key",
      descending: true
    },
    headers: [
      {
        text: "DonorID",
        value: "donorId"
      },
      {
        text: "UMRN",
        value: "UMRN"
      },
      {
        text: "Name",
        value: "name"
      },
      // {
      //   text: "Email",
      //   value: "email"
      // },
      // {
      //   text: "Phone",
      //   value: "phone"
      // },

      {
        text: "Start",
        value: "dateStart"
      },
      {
        text: "End",
        value: "dateEnd"
      },
      {
        text: "Slot",
        value: "slot",
        align: "center"
      },
      {
        text: "Amount",
        value: "amount",
        align: "right"
      },
      {
        text: "Status",
        value: "stage",
        align: "right"
      }
    ],
    isLoading: false,
    activeIndex: 0
  }),

  computed: {
    donationList() {
      return this.$store.getters.donationList(this.selectedStatus);
    },

    activeItem() {
      return Object.assign({}, this.donationList[this.activeIndex]);
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    formatDate(timestamp) {
      return timestamp ? new Date(timestamp).toString().substring(4, 24) : "-";
    },

    formatDateDDMMYYY(date) {
      return date.replace(/-/g, "");
    },

    msg(item) {
      return monthFromDate(this.getLastMonth(item));
    },

    getLastHistory(history) {
      const entries = Object.values(history);

      entries.sort((a, b) => {
        let dateA = toDefaultDate(a.dateTime);
        let dateB = toDefaultDate(b.dateTime);
        return dateA - dateB;
      });
      return entries.pop();
    },

    getLastStatus(item) {
      if (item.history) {
        return this.getLastHistory(item.history).status || "";
      }
      return item.status;
    },

    getLastMonth(item) {
      if (item.history) {
        return this.getLastHistory(item.history).dateTime || "";
      }
      return "";
    },

    setActiveItem(item) {
      this.activeIndex = this.donationList.indexOf(item);
      this.drawer = true;
    },

    deleteItem(item) {
      if (
        confirm(
          "Are you sure you want to delete this record? \nNote: This will cancel all future Monthly donations permenantly!"
        )
      ) {
        this.$store.dispatch("deleteDonation", item);
        this.drawer = false;
      }
    },

    setLoading(status = true) {
      if (!status) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
        this.activeItem.info = "Loading...";
      }
    },

    triggerDonate(item) {
      if (
        !confirm(
          "Are you sure you want to Trigger this donation? \nNote: This will initiate the money transfer from the Doner!"
        )
      ) {
        return;
      }

      this.setLoading();

      const key = item.key;
      const UMRN = item.UMRN;
      const amount = item.amount;

      const URL =
        "https://us-central1-guardians-of-dreams.cloudfunctions.net/triggerMonthlyDonationAPI";

      axios
        .get(URL, {
          crossdomain: true,
          params: { key, UMRN, amount }
        })
        .then(response => {
          this.setLoading(false);
          console.log(response);
        })
        .catch(error => {
          this.setLoading(false);
          console.log(error);
        });
    },

    triggerAllDonate(item) {
      this.setLoading();

      const URL =
        "https://us-central1-guardians-of-dreams.cloudfunctions.net/triggerAllMonthlyDonationsAPI";

      axios
        .get(URL, {
          crossdomain: true,
          params: {}
        })
        .then(response => {
          console.log("triggerAllDonate::", response);
        })
        .catch(error => {
          console.log("triggerAllDonate::", error);
        });
    },

    varifyTransaction({ key, trnId, dateTime }) {
      this.setLoading();

      const URL =
        "https://us-central1-guardians-of-dreams.cloudfunctions.net/transactionVarificationAPI";

      axios
        .get(URL, {
          crossdomain: true,
          params: { key, trnId, dateTime }
        })
        .then(response => {
          this.setLoading(false);
          console.log(response);
        })
        .catch(error => {
          this.setLoading(false);
          console.log(error);
        });
    },

    handleHistoryClick(key, trnId, dateTime) {
      this.varifyTransaction({ key, trnId, dateTime });
    }
  }
};
</script>

<style>
table.v-table thead th:not(:first-child),
table.v-table thead th:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody td:first-child {
  padding: 0 8px;
}

.v-select__selection--comma,
.v-list__tile__title,
.v-chip__content,
.name {
  text-transform: capitalize;
}

.filter {
  padding-right: 2%;
}

.no-wrap {
  white-space: nowrap;
}

.donation-page .v-table .v-chip .v-avatar {
  margin-right: 0;
}

.donation-page .v-card__title {
  padding-bottom: 0;
}

.donation-page .v-navigation-drawer table.v-table tbody td:first-child {
  color: #666666;
  text-align: right;
  width: 25%;
}
.donation-page .v-navigation-drawer table.v-table tbody tr.loader {
  border: none;
}
.donation-page .v-navigation-drawer table.v-table tbody tr.loader td {
  margin: 0;
  padding: 0;
  height: auto;
}

.donation-page .v-navigation-drawer .v-progress-linear {
  margin: 0;
}

.donation-page .v-navigation-drawer table.table td {
  padding: 15px 10px;
}

.donation-page .v-navigation-drawer a {
  color: #032b72;
}

.donation-page .v-navigation-drawer .contact td {
  line-height: 1.8em;
  padding-top: 15px;
  padding-bottom: 15px;
  vertical-align: top;
}

.donation-page .v-navigation-drawer .status td {
  min-height: 48px;
}
</style>




// WEBPACK FOOTER //
// src/pages/DonationsPage.vue